import { Claims } from '../utils/services/cache/ClientCache'
const axios = require('axios');

export const getNotificationItems = async () => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Notification/GetNotificationByNumberStudent`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const updateNotificationById = async (id) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}Notification/UpdateNotificationById/${id}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};